
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, UserCheck, Clock, UserX } from 'lucide-react';
import { User } from '@/types/user';
import { Organization } from '@/types/auth';

interface OrganizationUsersStatsProps {
  users: User[];
  organization: Organization | null;
}

export function OrganizationUsersStats({ users, organization }: OrganizationUsersStatsProps) {
  const activeUsers = users.filter(user => user.status === 'Active');
  const pendingUsers = users.filter(user => user.invitationStatus === 'pending');
  const inactiveUsers = users.filter(user => user.status === 'Inactive');
  const maxMembers = organization?.max_team_members || 10;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Members</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{users.length}</div>
          <p className="text-xs text-muted-foreground">
            of {maxMembers} allowed
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Active Members</CardTitle>
          <UserCheck className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{activeUsers.length}</div>
          <p className="text-xs text-muted-foreground">
            Ready to participate
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Pending Invitations</CardTitle>
          <Clock className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{pendingUsers.length}</div>
          <p className="text-xs text-muted-foreground">
            Awaiting response
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Inactive Members</CardTitle>
          <UserX className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{inactiveUsers.length}</div>
          <p className="text-xs text-muted-foreground">
            Deactivated users
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
